import api from './client';
import ApiError from './error';

const AttributeService = {
  async searchAttributes({ params }) {
    try {
      const client = await api.getClient();
      return client.searchAttributes(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getAttribute({ id }) {
    try {
      const client = await api.getClient();
      return client.viewAttribute(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createAttribute({ attribute }) {
    try {
      const client = await api.getClient();
      return client.createAttribute(null, attribute);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateAttribute({ id, attribute }) {
    try {
      const client = await api.getClient();
      return client.updateAttribute(id, attribute);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteAttribute({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteAttribute(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

};

export default AttributeService;
